module.exports = __webpack_public_path__ + "img/13.c8fd7731.jpg";